import { Injectable } from '@angular/core';
import { ProductionOrderDsService } from '@app/core/data-services';
import { Observable } from 'rxjs';
import { MachineScheduleViewModel, ProductionOrderDeviationEntry } from 'chronos-core-client';
import { switchMap } from 'rxjs/operators';
import { ActiveWorkCenterService } from '@app/core/workcenter';

@Injectable()
export class ModalDeviationProductionSequenceService {
  constructor(private productionOrderDsService: ProductionOrderDsService, private activeWorkCenterService: ActiveWorkCenterService) {}

  public setNextProductionOrder(
    productionOrderId: number,
    reasonId,
    comment: string,
    showAll: boolean
  ): Observable<MachineScheduleViewModel[]> {
    const workCenterId = this.activeWorkCenterService.getWorkCenterId();
    const entry: ProductionOrderDeviationEntry = {
      workCenterId,
      additionalInfo: comment,
      deviationReasonId: reasonId
    };
    return this.productionOrderDsService
      .setAsNextOrder(productionOrderId, entry)
      .pipe(switchMap(() => this.productionOrderDsService.loadProductionOrderListByShift(showAll)));
  }
}
